<div class="app-header">
  <!-- Left Logo -->
  <div class="header-part logo-left">
    <img src="../../../../assets/openpyq.png" alt="OpenPYQ" class="header-logo">
  </div>
  <!-- Right Logo -->
  <div class="header-part logo-right">
    <img src="../../../../assets/Angular.png" alt="Partner Logo" class="header-logo">
  </div>
  <!-- Center Welcome -->
  <div class="header-part welcome-message">
    <span class="welcome-text">Welcome to OpenPYQ</span>
  </div>
  <!-- User + Logout -->
  <div class="header-part user-section">
    <div class="user-controls">
      <div class="button-container">
        <a class="admin-button"
             (click)="navigateToggle($event)"
             style="cursor: pointer; color: white !important; text-decoration: none;"
             *ngIf="isAdminPage || isAdminUser">
          {{ isAdminPage ? 'Main App' : 'Admin Panel' }}
        </a>
        <button class="logout-button"
             (click)="logout()"
             style="cursor: pointer; color: white !important;">
          Logout
        </button>
        <button class="icon-button settings-button"
             (click)="onSettingsClick()"
             matTooltip="Settings">
          <mat-icon>settings</mat-icon>
        </button>
      </div>
      <div class="username-container">
        <span class="user-text">{{userName}}</span>
      </div>
    </div>
  </div>
</div>
